import axios from "axios";
import { jwtDecode } from "jwt-decode";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL
});

const tokenIsExpired = (token) => {
  try {
    const { exp } = jwtDecode(token);
    if (!exp) return true;
    return Date.now() >= exp * 1000;
  } catch {
    return true;
  }
};

// Attach token to protected requests only.
api.interceptors.request.use(config => {
  if (config.skipAuth) return config;

  const token = localStorage.getItem("access_token");
  if (!token) return config;

  if (tokenIsExpired(token)) {
    localStorage.removeItem("access_token");
    return config;
  }

  config.headers = config.headers ?? {};
  config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;
